import { SVG } from '../SVG'

const CalendarCheckIcon = ({ style = {}, ...props }) => {
  return (
    <SVG
      width='55'
      height='55'
      viewBox='0 0 55 55'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ stroke: 'var(--primary-color)', ...style }}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <path d='M44.6875 8.59375H10.3125C9.36326 8.59375 8.59375 9.36326 8.59375 10.3125V44.6875C8.59375 45.6367 9.36326 46.4062 10.3125 46.4062H44.6875C45.6367 46.4062 46.4062 45.6367 46.4062 44.6875V10.3125C46.4062 9.36326 45.6367 8.59375 44.6875 8.59375Z' />
      <path d='M37.8125 5.15625V12.0312' />
      <path d='M17.1875 5.15625V12.0312' />
      <path d='M8.59375 18.9062H46.4062' />
      <path d='M35.2344 27.5L25.2012 36.9531L19.7656 31.7969' />
    </SVG>
  )
}

export default CalendarCheckIcon
